import React, {Fragment, useEffect, useState} from "react";
import withLanguage from "../../HOC/withLanguage";
import {Link} from "react-router-dom";
import {handleDocumentDownload} from "../Shared/helperFunctions";
import FaqAccordion from "./ArsimiDualComponents/FaqAccordion";

function NxenesPunemarres({ language = {}, endpoint, truncateAt = 100 }) {

    const lang = language;


    const [stats, setStats] = useState({});

    useEffect(() => {
        fetch("/api/statistic_data/statistic_dual_system")
            .then((res) => res.json())
            .then((data) => {
                setStats(data.records);
            })
            .catch((err) => console.error("API fetch error:", err));
    }, []);

    console.log(stats);

    return (
        <>
            <div>
                {/* CENTERED SECTION */}
                <div className="max-w-6xl mx-auto px-6 mt-10">
                    <div className="flex-1 w-full">
                        <h1 className="text-[28px] font-extrabold text-red-600 mb-4">{lang.mainTitle}</h1>
                        <p className="max-w-[548px] font-extrabold mb-4">{lang.subText}</p>

                        {/* BUTTONS - ROW ON DESKTOP, COLUMN ON MOBILE */}
                        <div className="flex flex-col sm:flex-row gap-4">
                            <Link
                                to="/KualifikimDual?page"
                                className="bg-red-600 text-white font-bold p-2 rounded-xl hover:bg-red-700 transition-colors text-center"
                            >
                                {language.redirectButton}
                            </Link>

                            <Link
                                to="/KualifikimDual?page=StudentApplication"
                                className="bg-red-600 text-white font-bold p-2 rounded-xl hover:bg-red-700 transition-colors text-center"
                            >
                                {language.redirectButton2}
                            </Link>
                        </div>
                    </div>
                </div>


                {/*///////////////////////////////////////*/}

                <section>
                    <div className="p-6">
                        <section className="max-w-6xl mx-auto px-6">
                            <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">{lang.Title1}</h1>

                            <div className="border-2 border-red-600 rounded-3xl p-6">
                                <p className="font-extrabold">{lang.subTitle1}</p>
                                <p>{lang.subText1}</p>
                                <p className=" max-w-[548px] font-extrabold pt-4">{lang.subTitle2 }</p>
                                <p>{lang.subText2}</p>
                                <p className="pt-4">{lang.subText3}</p>
                                <p>
                                    <span>{language.subText31} </span>
                                    <span
                                        onClick={() => handleDocumentDownload("/documents/Kontrate dual.pdf")}
                                        className="text-blue-500 font-bold cursor-pointer"
                                    >
                                        {language.subText3Download}
                                    </span>
                                </p>
                            </div>
                        </section>
                    </div>

                    {/*/////////////////////////////////////*/}

                    <div className="p-6">
                        <section className="max-w-6xl mx-auto px-6">
                            <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">
                                {lang.Title2}
                            </h1>

                            <div className="border-2 border-red-600 rounded-3xl p-6">


                                <p> {lang.subText4} <span className="font-bold">  {lang.subTextBold} </span> {lang.subTextContinue} </p>

                                <p>{lang.subText5}</p>
                                <p>{lang.subText6}</p>
                                <p>{lang.subText7}</p>
                                <p> {lang.subText8} <span className="font-bold">  {lang.subTextBold2} </span> {lang.subTextContinue} </p>
                                <p>{lang.subText9}</p>
                            </div>
                        </section>
                    </div>

                    {/*/////////////////////////////////////*/}

                    <div className="p-6">
                        <section className="max-w-6xl mx-auto px-6">
                            <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">
                                {lang.Title3}
                            </h1>

                            <div className="border-2 border-red-600 rounded-3xl p-6">
                                <p className=" max-w-[548px]">{lang.subText10}</p>
                                <p className=" max-w-[548px]">{lang.subText11}</p>
                                <p className=" max-w-[548px]">{lang.subText12}</p>
                            </div>
                        </section>
                    </div>

                    {/*//////////////////////////////////*/}

                    <div className="p-6">
                        <section className="max-w-6xl mx-auto px-6">
                            <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">
                                {lang.Title4}
                            </h1>

                            <div className="border-2 border-red-600 rounded-3xl p-6">
                                <p className="pb-6">
                                    <a href="https://qbz.gov.al/share/vRUBQETTSzetSUtAvFYAFQ"
                                       target="_blank"
                                       className="text-blue-600 underline hover:text-blue-800">
                                        {lang.subText13}
                                    </a>
                                </p>

                                <p className="pb-6">
                                    <a href="https://qbz.gov.al/share/kdc6oZetSDqUST7vz5tseA"
                                       target="_blank"
                                       className="text-blue-600 underline hover:text-blue-800">
                                        {lang.subText14}
                                    </a>
                                </p>

                                <p className="pb-6">
                                    <a href="https://qbz.gov.al/share/fn-l5ZzCQPOycy1bSugm7g"
                                       target="_blank"
                                       className="text-blue-600 underline hover:text-blue-800">
                                        {lang.subText15}
                                    </a>
                                </p>

                                <p className="pb-6">
                                    <a href="https://qbz.gov.al/share/9D25wUM_QrSIjVUzhCRGxw"
                                       target="_blank"
                                       className="text-blue-600 underline hover:text-blue-800">
                                        {lang.subText16}
                                    </a>
                                </p>
                            </div>
                        </section>
                    </div>

                    {/*//////////////////////////////////*/}

                    <FaqAccordion whereIsShown="student" title={language.faqTitle} />

                    {/*//////////////////////////////////*/}

                    <section className=" max-w-5xl mx-auto py-6">
                        <div>
                            <h2 className="text-red-600 font-extrabold text-[20px] mb-6">
                                {lang.StatsTitle}
                            </h2>

                            <div className="grid grid-cols-2 md:grid-cols-3 mb-10">
                                <div className="flex flex-col items-center">
                                    <div className="border-2 border-red-600 rounded-3xl p-6">
                                        <img src="/dual/Picture8.png" alt="Description" />
                                        <p className="text-gray-800 font-bold text-center pt-1">
                                            {stats[0]?.student_employee_count} {language.stat1}
                                        </p>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center">
                                    <div className="border-2 border-red-600 rounded-3xl p-6">
                                        <img src="/dual/Picture9.png" alt="Description" />
                                        <p className="text-gray-800 font-bold text-center pt-1">
                                            {stats[0]?.student_employee_count} {language.stat2}
                                        </p>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center">
                                    <div className="border-2 border-red-600 rounded-3xl p-3.5">
                                        <img src="/dual/Picture10.png" alt="Description" />
                                        <p className="text-gray-800 font-bold text-center max-w-[220px] pt-1">
                                            {stats[0]?.student_employee_count} {language.stat3}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*/////////*/}

                        <div className="mb-10">
                            <h2 className="text-red-600 font-extrabold text-[20px] mb-6">
                                {lang.UsefulPagesTitle}
                            </h2>

                            <div className="grid grid-cols-2 md:grid-cols-3">
                                <div className="flex flex-col items-center">
                                    <div className="bg-gray-200 border border-gray-130 rounded-2xl p-3.5">
                                        <a href="https://www.puna.gov.al/home"
                                           target="_blank"
                                           className="text-[17px] font-extrabold text-center text-black underline underline-offset-2 decoration-black">
                                            {lang.page1}
                                        </a>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center">
                                    <div className="bg-gray-200 border border-gray-130 rounded-2xl p-3.5">
                                        <a href="https://www.tatime.gov.al/"
                                           target="_blank"
                                           className="text-[17px] font-extrabold text-center text-black underline underline-offset-2 decoration-black">
                                            {lang.page2}
                                        </a>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center">
                                    <div className="bg-gray-200 border border-gray-130 rounded-2xl p-3.5">
                                        <a href="https://inspektoriatipunes.gov.al/"
                                           target="_blank"
                                           className="text-[17px] font-extrabold text-center text-black underline underline-offset-2 decoration-black">
                                            {lang.page3 || "inspektoratipunes.gov.al"}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </div>
        </>
    );
}


export default withLanguage(NxenesPunemarres, "NxenesPunemarres");
